export default __webpack_public_path__ + "static/media/plain-sticker-n.a69053ae.png";